import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { calculateAge } from '../helpers/calculateAge';
import DateComponent from './dateComponent';
import dayjs from 'dayjs'; // Import dayjs
import { Stack } from '@mui/material';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { PATIENT_FILE_TAGS } from '../../../constants';
import ImageUploader from './imageUploader';
import PhoneInput from 'react-phone-input-2';

export const isOtherValue = (value) => {
  if (
    ![
      'Single',
      'Married',
      'Divorced',
      'Widowed',
      'Separated',
      'Domestic',
      'Partner',
    ].includes(value)
  ) {
    return true;
  }
  return false;
};

const PartnerInformationForm = ({
  patientFormData,
  setPatientFormData,
  submeet,
  validateField,
  validateExactLength,
  validateIsNumber,
  validateEmail,
  validatePhoneNumber,
  touchedFields,
  setTouchedFields,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [effectRan, setEffectRan] = useState(false); // State to track if effect has run
  const [otherValue, setOtherValue] = useState('');

  useEffect(() => {
    if (!patientFormData.partnerInformation.dob) {
      setSelectedDate(null);
    }
    if (!effectRan && patientFormData.partnerInformation.dob) {
      const parsedDate = dayjs(patientFormData.partnerInformation.dob);
      if (!parsedDate.isValid()) {
        console.error('Invalid date format');
        return;
      }

      const age = calculateAge(parsedDate);
      setSelectedDate(parsedDate);
      setPatientFormData({
        ...patientFormData,
        partnerInformation: {
          ...patientFormData.partnerInformation,
          dob: patientFormData.partnerInformation.dob,
          age: age,
        },
      });
    }
    setOtherValue(patientFormData.partnerInformation.maritalStatus);
  }, [effectRan, patientFormData.partnerInformation.dob]);

  const handleDateChange = (date, dateString) => {
    setSelectedDate(date);
    const age = calculateAge(date);
    setPatientFormData({
      ...patientFormData,
      partnerInformation: {
        ...patientFormData.partnerInformation,
        dob: dateString,
        age: age,
      },
    });
  };

  const changeHandler = (e) => {
    setPatientFormData({
      ...patientFormData,
      partnerInformation: {
        ...patientFormData.partnerInformation,
        [e.target.name]: e.target.value,
      },
    });
  };
  const uploadImageAndSave = async (selectedFile, patientId) => {
    try {
      const response = await uploadPatientFileApi(
        selectedFile,
        patientId,
        'Profile',
        updateFileStatusUploaded,
        PATIENT_FILE_TAGS.PARTNER_PROFILE_IMAGE,
      );
    } catch (error) {
      console.log('Error uploading file:', error);
      throw new Error('File upload failed');
    }
  };

  return (
    <form>
      <div className="card">
        <div className="header">
          <p className="lead">Partner/Guardian Information</p>
        </div>
        <div className="body">
          <div className="row clearfix">
            <ImageUploader
              name="partnerProfileImage"
              profileImageUrl={
                patientFormData.partnerInformation.profileImagePresignedUrl
              }
              buttonLabel={'Upload'}
              bodyLabel={'Upload profile image'}
              uploadAndSaveHandler={uploadImageAndSave}
            />
          </div>
          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-12">
              <label>
                First Name
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.partnerInformation.PartnerFirstName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.PartnerFirstName, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.partnerInformation.PartnerFirstName}
                name="PartnerFirstName"
                required
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.PartnerFirstName === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(
                patientFormData.partnerInformation.PartnerFirstName,
                50,
              ).errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.PartnerFirstName,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>
            <div className="form-group col-lg-4 col-md-12">
              <label>Middle Name</label>
              <input
                className={`form-control`}
                value={patientFormData.partnerInformation.PartnerMiddleName}
                name="PartnerMiddleName"
                onChange={changeHandler}
              />
            </div>
            <div className="form-group col-lg-4 col-md-12">
              <label>
                Last Name
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.partnerInformation.PartnerLastName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.PartnerLastName, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.partnerInformation.PartnerLastName}
                name="PartnerLastName"
                required
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.PartnerLastName === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(
                patientFormData.partnerInformation.PartnerLastName,
                50,
              ).errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.PartnerLastName,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>
          </div>

          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-12">
              <label>
                Aadhar Number
                {!patientFormData.partnerInformation.isNRI && (
                  <span className="mandatory_fields">*</span>
                )}
              </label>
              <input
                // className={`form-control ${(patientFormData.partnerInformation.adharNumber === '' || !/^\d{1,12}$/.test(patientFormData.partnerInformation.adharNumber)) && submeet && 'parsley-error'}`}
                className={`form-control ${touchedFields.partnerAdharNumber && !validateExactLength(patientFormData.partnerInformation.adharNumber, 12) ? 'is-invalid' : ''}`}
                value={patientFormData.partnerInformation.adharNumber}
                name="adharNumber"
                required=""
                // onChange={(e) => {
                // const value = e.target.value;
                // if (/^\d{0,12}$/.test(value)) {
                //     setFormData((prevData) => ({
                //     ...prevData,
                //     adharNumber: value,
                //     }));
                //     setSubmeet(false);
                // }
                // }}
                onChange={(e) => {
                  changeHandler(e);
                  setTouchedFields({
                    ...touchedFields,
                    partnerAdharNumber: true,
                  });
                }}
              />
              {/* {patientFormData.partnerInformation.adharNumber === '' &&
              submeet ? (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              ) : null} */}

              {touchedFields.partnerAdharNumber &&
                !validateExactLength(
                  patientFormData.partnerInformation.adharNumber,
                  12,
                ) && (
                  <span className="error">
                    Aadhar Number should be exactly 12 digits.
                  </span>
                )}
            </div>

            <div className="form-group col-lg-4 col-md-6">
              <input
                type="checkbox"
                checked={patientFormData.partnerInformation.isNRI}
                name="isNRI"
                onChange={(e) => {
                  setPatientFormData({
                    ...patientFormData,
                    partnerInformation: {
                      ...patientFormData.partnerInformation,
                      isNRI: e.target.checked,
                    },
                  });
                }}
                id="isNRI"
                className=""
                style={{
                  marginTop: '45px',
                }}
              />
              <label htmlFor="isNRI" className="ml-3">
                Is NRI/Foreigner
              </label>
            </div>

            <div className="form-group col-lg-4 col-md-6">
              <label>
                Passport Number
                {patientFormData.partnerInformation.isNRI && (
                  <span className="mandatory_fields">*</span>
                )}
              </label>
              <input
                // className={`form-control ${patientFormData.basicDetails.adharNumber === '' && submeet && 'parsley-error'}`}
                className={`form-control`}
                value={patientFormData.partnerInformation.passportNumber}
                name="passportNumber"
                required=""
                onChange={(e) => {
                  changeHandler(e);
                }}
              />
            </div>
            <div className="form-group col-lg-4 col-md-6">
              <label>Email</label>
              <input
                className={`form-control `}
                value={patientFormData.partnerInformation.PartnerEmail}
                name="PartnerEmail"
                onChange={changeHandler}
              />
            </div>
            <div className="form-group col-lg-3 col-md-12">
              <label>Date of Birth </label>
              <DateComponent
                selectedDate={selectedDate}
                handleDateChange={handleDateChange}
              />
            </div>
            <div className="form-group col-lg-1 col-md-12">
              <label>Age</label>
              <input
                disabled
                className={`form-control`}
                value={patientFormData.partnerInformation.age}
                name="age"
                // onChange={changeHandler}
              />
            </div>
          </div>

          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-12">
              <label>Preferred Language</label>
              <input
                className={`form-control`}
                value={patientFormData.partnerInformation.preferredLanguage}
                name="preferredLanguage"
                required=""
                onChange={changeHandler}
              />
            </div>

            <div
              className="form-group col-lg-4 col-md-12"
              style={{ marginTop: '28px' }}
            >
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label className="input-group-text">Marital Status</label>
                </div>
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  name="maritalStatus"
                  value={
                    isOtherValue(
                      patientFormData.partnerInformation.maritalStatus,
                    )
                      ? 'Other'
                      : patientFormData.partnerInformation.maritalStatus
                  }
                  required
                  onChange={changeHandler}
                >
                  <option value="Single">Single</option>
                  <option value="Married">Married</option>
                  <option value="Divorced">Divorced</option>
                  <option value="Widowed">Widowed</option>
                  <option value="Separated">Separated</option>
                  <option value="Domestic">Domestic</option>
                  <option value="Partner">Partner</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              {isOtherValue(
                patientFormData.partnerInformation.maritalStatus,
              ) && (
                <input
                  type="text"
                  className="form-control other-text-field"
                  name="maritalStatus"
                  value={otherValue}
                  onChange={(e) => {
                    setOtherValue(e.target.value);
                    changeHandler(e);
                  }}
                  placeholder="Specify please"
                />
              )}
            </div>
            <div
              className="form-group col-lg-4 col-md-6"
              style={{ marginTop: '28px' }}
            >
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label className="input-group-text">Gender</label>
                </div>
                <select
                  className="custom-select"
                  id="inputGroupSelect01"
                  name="gender"
                  value={patientFormData.partnerInformation.gender}
                  required
                  defaultValue={'male'}
                  onChange={changeHandler}
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
            </div>
            {/* <div className="form-group col-lg-3 col-md-6">
              <label>Emergency contact</label>
              <input
                className={`form-control ${patientFormData.partnerInformation.PartnerEmergency === '' && submeet && 'parsley-error'}`}
                value={patientFormData.partnerInformation.PartnerEmergency}
                name="PartnerEmergency"
                required
                onChange={changeHandler}
              />
              {patientFormData.partnerInformation.PartnerEmergency === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )}
            </div> */}

            {/* <div className="form-group col-lg-4 col-md-6">
              <label>Emergency Address</label>
              <input
                className={`form-control ${patientFormData.partnerInformation.EmergencyAddress === '' && submeet && 'parsley-error'}`}
                value={patientFormData.partnerInformation.EmergencyAddress}
                name="EmergencyAddress"
                required
                onChange={changeHandler}
              />
              {patientFormData.partnerInformation.EmergencyAddress === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )}
            </div> */}
          </div>

          <div className="row clearfix">
            <div className="form-group col-lg-4 col-md-6">
              <label>Occupation</label>
              <input
                className={`form-control`}
                value={patientFormData.partnerInformation.occupation}
                name="occupation"
                onChange={changeHandler}
              />
            </div>

            <div className="form-group col-lg-4 col-md-6">
              <label>
                Cell Phone
                <span className="mandatory_fields">*</span>
              </label>
              <PhoneInput
                country={'in'}
                value={patientFormData.partnerInformation.phone}
                onChange={(phone) => {
                  setPatientFormData({
                    ...patientFormData,
                    partnerInformation: {
                      ...patientFormData.partnerInformation,
                      phone: phone,
                    },
                  });
                  setTouchedFields({
                    ...touchedFields,
                    partnerPhoneNumber: true,
                  });
                }}
                disableDropdown={false}
                onlyCountries={['in', 'us', 'ca', 'uk']}
                disableCountryCode={false}
                inputProps={{
                  required: true,
                  placeholder: 'Enter your phone number',
                }}
              />
              {/* <input
                className={`form-control ${patientFormData.partnerInformation.phone === '' && submeet && 'parsley-error'}`}
                value={patientFormData.partnerInformation.phone}
                name="phone"
                required
                onChange={changeHandler}
              /> */}
              {/* {patientFormData.partnerInformation.phone === '' && submeet ? (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              ) : null} */}

              {touchedFields.partnerPhoneNumber &&
                !validatePhoneNumber(
                  patientFormData.partnerInformation.phone,
                ) && (
                  <span className="error">
                    Please enter a valid phone number.
                  </span>
                )}
            </div>

            <div className="form-group col-lg-4 col-md-6">
              <label>Home Phone</label>
              {/* <PhoneInput
                country={'in'}
                value={patientFormData.partnerInformation.homePhone}
                onChange={(homePhone) => {
                  setPatientFormData({
                    ...patientFormData,
                    partnerInformation: {
                      ...patientFormData.partnerInformation,
                      homePhone: homePhone,
                    },
                  });
                }}
                disableDropdown={true}
                onlyCountries={['in']}
                disableCountryCode={true}
              /> */}
              <input
                className={`form-control`}
                value={patientFormData.partnerInformation.homePhone}
                name="homePhone"
                onChange={changeHandler}
              />
            </div>
          </div>
          <div className="row clearfix">
            <div className="form-group col-lg-3 col-md-12">
              <label>
                Relation with the Patient
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.partnerInformation.relationWithPatient === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.relationWithPatient, 50).isInvalid ? 'is-invalid' : ''}`}
                value={patientFormData.partnerInformation.relationWithPatient}
                name="relationWithPatient"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.relationWithPatient === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(
                patientFormData.partnerInformation.relationWithPatient,
                50,
              ).errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.relationWithPatient,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>
          </div>
          <div className="flex col-lg-8 col-md-12 grey-box">
            <h6 className="col-lg-12 col-md-12">Address</h6>
            <div className="form-group col-lg-6 col-md-12">
              <label>
                Street Address
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.partnerInformation.PartnerAddress === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.PartnerAddress, 50).isInvalid ? 'is-invalid' : ''}`}
                disabled={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                value={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                    ? patientFormData.basicDetails.address
                    : patientFormData.partnerInformation.PartnerAddress
                }
                name="PartnerAddress"
                required
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.PartnerAddress === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(
                patientFormData.partnerInformation.PartnerAddress,
                50,
              ).errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.PartnerAddress,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>
            <div className="form-group col-lg-6 col-md-12">
              <label>
                City
                <span className="mandatory_fields">*</span>
              </label>
              <input
                disabled={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                // className={`form-control ${patientFormData.partnerInformation.CityName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.CityName, 50).isInvalid ? 'is-invalid' : ''}`}
                value={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                    ? patientFormData.basicDetails.CityName
                    : patientFormData.partnerInformation.CityName
                }
                name="CityName"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.CityName === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(patientFormData.partnerInformation.CityName, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.CityName,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>

            <div className="form-group col-lg-6 col-md-6">
              <label>
                State
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${patientFormData.partnerInformation.StateName === '' && submeet && 'parsley-error'}`}
                className={`form-control ${validateField(patientFormData.partnerInformation.StateName, 50).isInvalid ? 'is-invalid' : ''}`}
                disabled={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                value={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                    ? patientFormData.basicDetails.StateName
                    : patientFormData.partnerInformation.StateName
                }
                name="StateName"
                required=""
                onChange={changeHandler}
              />
              {/* {patientFormData.partnerInformation.StateName === '' &&
                submeet && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                )} */}
              {validateField(patientFormData.partnerInformation.StateName, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.StateName,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>

            <div className="form-group col-lg-6 col-md-12">
              <label>
                Country<span className="mandatory_fields">*</span>
              </label>
              <input
                className={`form-control ${validateField(patientFormData.partnerInformation.country, 50).isInvalid ? 'is-invalid' : ''}`}
                disabled={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                value={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                    ? patientFormData.basicDetails.country
                    : patientFormData.partnerInformation.country
                }
                name="country"
                required=""
                onChange={changeHandler}
              />
              {validateField(patientFormData.partnerInformation.country, 50)
                .errorMessage && (
                <span className="error">
                  {
                    validateField(
                      patientFormData.partnerInformation.country,
                      50,
                    ).errorMessage
                  }
                </span>
              )}
            </div>

            <div className="form-group col-lg-6 col-md-6">
              <label>
                Pin
                <span className="mandatory_fields">*</span>
              </label>
              <input
                // className={`form-control ${(patientFormData.partnerInformation.zip === '' || !/^\d{1,6}$/.test(patientFormData.partnerInformation.zip)) && submeet && 'parsley-error'}`}
                className={`form-control ${touchedFields.partnerZip && !validateIsNumber(patientFormData.partnerInformation.zip) ? 'is-invalid' : ''}`}
                disabled={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                value={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                    ? patientFormData.basicDetails.zip
                    : patientFormData.partnerInformation.zip
                }
                name="zip"
                required=""
                onChange={(e) => {
                  changeHandler(e);
                  setTouchedFields({ ...touchedFields, partnerZip: true });
                }}
              />
              {/* {patientFormData.partnerInformation.zip === '' && submeet ? (
                <ul className="parsley-errors-list filled" id="parsley-id-29">
                  <li className="parsley-required">This value is required.</li>
                </ul>
              ) : null} */}
              {touchedFields.partnerZip &&
                !validateIsNumber(patientFormData.partnerInformation.zip) && (
                  <span className="error">
                    Please enter a valid number in zip.
                  </span>
                )}
            </div>

            <div className="form-group col-lg-12 col-md-12">
              <input
                type="checkbox"
                checked={
                  patientFormData.partnerInformation.partnerAddrSameAsSelf
                }
                name="partnerAddrSameAsSelf"
                onChange={(e) => {
                  setPatientFormData({
                    ...patientFormData,
                    partnerInformation: {
                      ...patientFormData.partnerInformation,
                      partnerAddrSameAsSelf: e.target.checked,
                      PartnerAddress: e.target.checked
                        ? patientFormData.basicDetails.address
                        : patientFormData.partnerInformation.PartnerAddress,
                      CityName: e.target.checked
                        ? patientFormData.basicDetails.CityName
                        : patientFormData.partnerInformation.CityName,
                      StateName: e.target.checked
                        ? patientFormData.basicDetails.StateName
                        : patientFormData.partnerInformation.StateName,
                      zip: e.target.checked
                        ? patientFormData.basicDetails.zip
                        : patientFormData.partnerInformation.zip,
                    },
                  });
                }}
                id="partnerAddrSameAsSelf"
                className="mr-1"
              />
              <label htmlFor="partnerAddrSameAsSelf">
                Same as patient address
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default PartnerInformationForm;
